const apiUrl = process.env.VUE_APP_API_BASEURL;

export default {
  setPrinted: `${apiUrl}/v2/taxcard/setPrinted`,
  getPreparePrintId: (transactionId: string, taxcards: string, customerUUID: string) =>
    `${apiUrl}/v2/print/prepare/${transactionId}/${taxcards}?customerUUID=${customerUUID}`,
  getPrintPDF: (printId: string, fileName: string) => `${apiUrl}/v2/print/${printId}/${fileName}.pdf`,
  sendShareMail: `${apiUrl}/v2/taxcard/share`,
};
